import type { PageLoad } from './$types';

export const load: PageLoad = async ({ params, url }) => {
	const { path } = params;
	const { searchParams } = url;

	const areValidParams = path && searchParams.get('aid');

	if (!areValidParams) {
		throw new Error('Missing params');
	}

	const searchExtensionPathAndParams = `${path}?${searchParams}`;
	return {
		searchExtensionPathAndParams,
	};
};
